import { format } from '@appd/uik';
import { get, merge } from 'lodash';
import { ContentAlignment, TableColumn, ColumnDef } from '../..';
import { CellTypeStrategy, getDefaultColumnDefParamsType } from '../models';
import { TimeseriesCellRenderer } from './TimeseriesCellRenderer';
import { SparklineCellRendererProps } from '../../../cartesian/SparklineCellRenderer';
import { ArrayPoint } from '../../../cartesian/models';
import { Timeseries } from './models';
import { DEFAULT_EMPTY_CELL_PLACEHOLDER } from '../../constants';

export class TimeseriesCell<TData> implements CellTypeStrategy<TData> {
  public getDefaultColumnDef({
    col,
    isClientSideData,
    metadata,
  }: getDefaultColumnDefParamsType<TData>): Partial<ColumnDef<TData>> {
    return {
      valueFormatter: param => {
        const value = get(param, 'value') as Timeseries[];
        const valueFormatEnabled = col?.valueFormatterOptions?.enabled;
        if (!valueFormatEnabled) {
          return value != null ? String(JSON.stringify(value, null, 2)) : DEFAULT_EMPTY_CELL_PLACEHOLDER;
        }
        const data: ArrayPoint[] =
          value?.map(({ timestamp, ...values }) => [Date.parse(timestamp), ...Object.values(values)] as ArrayPoint) ??
          [];
        const summaryValueColumn = (col?.cellTypeOptions as SparklineCellRendererProps)?.summaryValueColumn;
        const summaryValue = summaryValueColumn
          ? get(param, `data.${summaryValueColumn}`)
          : data && data.length > 0
          ? data[data.length - 1][1] // use last value by default
          : null;
        const displayValue = summaryValue ? format.number.short(summaryValue) : null;
        return displayValue != null ? String(displayValue) : '';
      },
      cellRenderer: TimeseriesCellRenderer,
      cellRendererParams: merge({}, col.cellRendererParams, { metadata }),
      sortable: false,
      // meta: {
      //   align: ContentAlignment.LEFT,
      // },
    };
  }
}
